/**
 * Centralized check for the REACT_APP_WITH_MOCK env flag.
 * Use this everywhere instead of reading process.env directly so we have a single
 * source of truth for "is the app running against mock data?".
 *
 * @param defaultFlag Optional override that, when truthy, forces the result to true.
 */
export default function isAppWithMock(defaultFlag?: boolean): boolean {
  if (defaultFlag) return true;
  return process.env.REACT_APP_WITH_MOCK === 'true';
}
